import _extends from "../../../@babel/runtime/helpers/esm/extends.es.js";
import _objectWithoutPropertiesLoose from "../../../@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.es.js";
import * as React from "react";
import { clsx } from "../../../clsx/dist/clsx.es.js";
import styled from "../../styled-engine/index.es.js";
import useTheme from "./useTheme.es.js";
import { j as jsxRuntimeExports } from "../../../react/jsx-runtime.es.js";
import styleFunctionSx from "./styleFunctionSx/styleFunctionSx.es.js";
import extendSxProp from "./styleFunctionSx/extendSxProp.es.js";
const _excluded = ["className", "component"];
function createBox(options = {}) {
  const {
    themeId,
    defaultTheme,
    defaultClassName = "MuiBox-root",
    generateClassName
  } = options;
  const BoxRoot = styled("div", {
    shouldForwardProp: (prop) => prop !== "theme" && prop !== "sx" && prop !== "as"
  })(styleFunctionSx);
  const Box = /* @__PURE__ */ React.forwardRef(function Box2(inProps, ref) {
    const theme = useTheme(defaultTheme);
    const _extendSxProp = extendSxProp(inProps), {
      className,
      component = "div"
    } = _extendSxProp, other = _objectWithoutPropertiesLoose(_extendSxProp, _excluded);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(BoxRoot, _extends({
      as: component,
      ref,
      className: clsx(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
      theme: themeId ? theme[themeId] || theme : theme
    }, other));
  });
  return Box;
}
export {
  createBox as default
};
//# sourceMappingURL=createBox.es.js.map
